"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:7.4.0'] && _();
}
catch (e) { }
